import { checklistComplementaryItems } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.ComplementaryItemsConstant';
import { checklistPortoComplementaryItems } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.PortoComplementaryItemsConstant';
import {
  ChecklistComplementItemResponse,
  ReportChecklistData,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';

interface Props {
  checklist: ReportChecklistData;
}

type ComplementaryItem = typeof checklistComplementaryItems[0];

const ReportChecklistPortoComplementItems: React.FC<Props> = ({
  checklist,
}) => {
  function getComplement(value: string) {
    return checklist.complementaryItems?.find(
      (item) => item.description === value,
    );
  }

  function renderRow(item: ComplementaryItem) {
    const complement = getComplement(item.value);

    return (
      <tr key={item.value}>
        <td>{item.label}</td>
        <td>
          {complement?.response === ChecklistComplementItemResponse.Ok && (
            <span className="icon-ok">&#9745;</span>
          )}
        </td>
        <td>
          {complement?.response === ChecklistComplementItemResponse.NotOk && (
            <span className="icon-notOk">&#9746;</span>
          )}
        </td>
        <td>
          {complement?.response === ChecklistComplementItemResponse.Warning && (
            <span className="icon-warning">&#9888;</span>
          )}
        </td>
        <td>{complement?.comment}</td>
      </tr>
    );
  }

  return (
    <div className="reportChecklist-complementItems">
      <div
        className={`reportChecklist-complementItems-header  ${
          checklist.company?.bosch ? '-bosch' : ''
        }`}
      >
        <span>Checklist complementar</span>
      </div>

      {checklistPortoComplementaryItems.map((category) => (
        <div key={category.key}>
          <table className="reportChecklist-complementItems-table">
            <thead>
              <tr>
                <th>{category.label}</th>
                <th>Ok</th>
                <th>Não Ok</th>
                <th>Atenção</th>
                <th>Observação</th>
              </tr>
            </thead>

            <tbody>
              {category.items
                .filter((item) => !!getComplement(item.value))
                .map(renderRow)}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default ReportChecklistPortoComplementItems;
